module.exports = __webpack_public_path__ + "img/eye-closed.e6859848.svg";